import styled from "styled-components";
export const Ticket = styled.div`
  margin: 10px;
  width: 100%;
  padding: 10px 15px;
  border-radius: 14px;
  box-shadow: 0 1px 3px 0 rgba(53, 58, 80, 0.1);
  background-color: #fff;
`;
export const DateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Status = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px
    ${(props) =>
      props.status !== 0
        ? "rgba(72, 207, 173, 0.2);"
        : "rgba(255, 191, 29, 0.2)"};
  background-color: ${(props) =>
    props.status !== 0
      ? "rgba(72, 207, 173, 0.1);"
      : "rgba(255, 191, 29, 0.1)"};
  padding: 0 17px;
  border-radius: 10px;
  color: ${(props) => (props.status !== 0 ? "#48cfad" : "#ffbf1d")};

  font-size: 10px;
  margin-bottom: 5px;
`;
export const Date = styled.div`
  color: rgba(53, 58, 80, 0.5);
  margin-left: 5px;
`;
export const CategoryContainer = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-items: center;
`;

export const AudioPlayer = styled.audio`
  border-radius: 8px;
  background-color: #fff;
  width: 60%;
  margin-top:10px ;
`;